import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";
import MDInput from "../../components/MDInput";
import UBKDate from "../../components/UBKDate";
import UBKfile from "../../components/UBKfile";
import { ConfigFile } from "../../services/ConfigFile";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import useSWR, { mutate as globalMutate } from "swr";
import { Button } from "antd";
import { Table, Pagination } from "antd";
import IconButton from "@mui/material/IconButton";
import { Drawer } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import useSWRMutation from "swr/mutation";
import {
  getNewData,
  addData,
  deleteData,
  updateData,
  addDataTigget,
  getadmindataUrl,
} from "../../Api/api";

import { Input } from "antd";
import Modal from "@mui/material/Modal";
import { addOptions, deleteTodoOptions } from "../../Api/apiOption";
//import EditSchool from "./EditSchool";
import MDButton from "../../components/MDButton";
import UBKRadio from "../../components/UBKRadio";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";



// ==========MAIN FUNCTION ======================

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,

  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: 2,
  boxShadow: 24,
  //p: 4,
};

function Payment() {
  
   let jsonString = JSON.parse(localStorage.getItem("userdata"));
   const { id ,admin_type} = jsonString;






 



return (
  <DashboardLayout>
    <DashboardNavbar />
   
    <Toaster toastOptions={{ position: "top-center" }} />
    <MDBox pt={8} pb={1}>
    
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={1}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Admin List
              </MDTypography>
            </MDBox>

           
            <MDBox pt={1}>
             
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  </DashboardLayout>
);
}


export default Payment;
